// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarElement_container__qCwaX","icon":"SidebarElement_icon__3FHl-","content":"SidebarElement_content__IA_NI"};